// Module
var code = "<p> Cultura Partenopea è il progetto di divulgazione culturale basato sulla bellezza che Napoli può offrire ogni giorno. Cibo, arte, musica, calcio. </p> ";
// Exports
export default code;